import React from "react";
import { CmmOrderTableRowData } from "../../../../../data-model/cmmOrderTableRowData";
import { MedicationProps } from "../types";
import DecisionDetailsCard from "./medicationLogic/decisionDetailsCard";
import MedicationOverviewCard from "./medicationLogic/medicationOverviewCard";
import MedicationThinkingCard from "./medicationLogic/medicationThinkingCard";
import { MedicationHeader } from "./ui";

const MedicationLogic: React.FC<MedicationProps> = ({ rowData }) => {
  const decision = rowData?.medicationDecisionResult;
  const hasDecision = decision && Object.keys(decision).length > 0;

  return (
    <div className="flex h-full w-full flex-col gap-2 border-1 border-primaryGray-15 bg-primaryGray-16">
      <MedicationHeader data={rowData as CmmOrderTableRowData} />
      <div className="flex h-full w-full flex-col gap-4 overflow-y-auto bg-primaryGray-16 p-3">
        <MedicationOverviewCard rowData={rowData} decision={decision} />
        {hasDecision && <DecisionDetailsCard decision={decision} />}
        {hasDecision && <MedicationThinkingCard decision={decision} />}
      </div>
    </div>
  );
};

export default MedicationLogic;
